import { Status, UserResponseDto } from '@clearbanc/baus-sdk';
import { CountryCodes } from '@clearbanc/data-common-types';

/**
 * We can't rely on the `auth0_id` for this check because it could conflict with newly invited users
 * who also might not have an `auth0_id` initially.
 */
export function userDoesNotHaveLogin(user: UserResponseDto): boolean {
  return !user.isPrimary && user.status === Status.Created;
}

export function userHasRequiredFieldsForVerification(
  user: UserResponseDto,
): boolean {
  // Check basic required fields
  const hasBasicFields = !!(
    user.firstName &&
    user.lastName &&
    user.birthday &&
    user.email &&
    user.phoneNumber &&
    (user.citizenship !== CountryCodes.US || user.personalTaxId)
  );

  // Check address completeness
  const hasAddress = !!(
    user.address?.line1 &&
    user.address?.city &&
    user.address?.country &&
    user.address?.postalCode
  );

  return hasBasicFields && hasAddress;
}
